/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { children_AllergyListResponse } from '../models/children_AllergyListResponse';
import type { children_AllergyResponse } from '../models/children_AllergyResponse';
import type { children_audit_ChildrenAuditHistoryResponse } from '../models/children_audit_ChildrenAuditHistoryResponse';
import type { children_audit_ChildrenAuditRecord } from '../models/children_audit_ChildrenAuditRecord';
import type { children_audit_UnifiedAuditHistoryResponse } from '../models/children_audit_UnifiedAuditHistoryResponse';
import type { children_ChildAttendanceResponse } from '../models/children_ChildAttendanceResponse';
import type { children_ChildAvatarResponse } from '../models/children_ChildAvatarResponse';
import type { children_ChildCohortResponse } from '../models/children_ChildCohortResponse';
import type { children_ChildExpectedTimesResponse } from '../models/children_ChildExpectedTimesResponse';
import type { children_ChildListResponse } from '../models/children_ChildListResponse';
import type { children_ChildScheduleResponse } from '../models/children_ChildScheduleResponse';
import type { children_CreateAllergyRequest } from '../models/children_CreateAllergyRequest';
import type { children_CreateChildRequest } from '../models/children_CreateChildRequest';
import type { children_CreateDiseaseRequest } from '../models/children_CreateDiseaseRequest';
import type { children_CreateMedicationRequest } from '../models/children_CreateMedicationRequest';
import type { children_DietSelectionListResponse } from '../models/children_DietSelectionListResponse';
import type { children_DietSelectionResponse } from '../models/children_DietSelectionResponse';
import type { children_DiseaseListResponse } from '../models/children_DiseaseListResponse';
import type { children_DiseaseResponse } from '../models/children_DiseaseResponse';
import type { children_MedicationListResponse } from '../models/children_MedicationListResponse';
import type { children_MedicationResponse } from '../models/children_MedicationResponse';
import type { children_NextInternalIDResponse } from '../models/children_NextInternalIDResponse';
import type { children_ReplaceChildExpectedTimesRequest } from '../models/children_ReplaceChildExpectedTimesRequest';
import type { children_SetChildAvatarRequest } from '../models/children_SetChildAvatarRequest';
import type { children_SleepHabitSelectionListResponse } from '../models/children_SleepHabitSelectionListResponse';
import type { children_SleepHabitSelectionResponse } from '../models/children_SleepHabitSelectionResponse';
import type { children_ToiletHabitSelectionListResponse } from '../models/children_ToiletHabitSelectionListResponse';
import type { children_ToiletHabitSelectionResponse } from '../models/children_ToiletHabitSelectionResponse';
import type { children_UpdateAllergyRequest } from '../models/children_UpdateAllergyRequest';
import type { children_UpdateChildRequest } from '../models/children_UpdateChildRequest';
import type { children_UpdateDiseaseRequest } from '../models/children_UpdateDiseaseRequest';
import type { children_UpdateMedicationRequest } from '../models/children_UpdateMedicationRequest';
import type { children_WeekdayHeadcountResponse } from '../models/children_WeekdayHeadcountResponse';
import type { models_Child } from '../models/models_Child';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChildrenService {
    /**
     * List children
     * List children with pagination, optional status filter, search, and sorting. A parent (or an admin viewing as one) gets their own children as children.ParentChildListResponse, each row the parent projection children.ParentChildResponse.
     * @param limit Limit
     * @param offset Offset
     * @param status Comma-separated status filter (ACTIVE, INACTIVE, UPCOMING). If not provided, returns all children.
     * @param search Search term to filter by firstname, lastname, or child_internal_id
     * @param sortBy Column to sort by (firstname, lastname, birthdate, status, created_at, child_internal_id)
     * @param sortOrder Sort direction (asc, desc)
     * @param groupId Comma-separated group IDs to filter children by allocation in those groups
     * @param groupMatch How group_id matches: active (default, only allocations covering today) or any (any allocation ever recorded for the group)
     * @param withContracts When true, only return children with current or upcoming contracts
     * @param childIds Comma-separated child IDs to filter by (injected by middleware for parent users)
     * @returns children_ChildListResponse OK
     * @throws ApiError
     */
    public static getApiV1Children(
        limit: number = 50,
        offset?: number,
        status?: string,
        search?: string,
        sortBy: string = 'firstname',
        sortOrder: string = 'asc',
        groupId?: string,
        groupMatch?: 'active' | 'any',
        withContracts?: boolean,
        childIds?: string,
    ): CancelablePromise<children_ChildListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children',
            query: {
                'limit': limit,
                'offset': offset,
                'status': status,
                'search': search,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'group_id': groupId,
                'group_match': groupMatch,
                'with_contracts': withContracts,
                'child_ids': childIds,
            },
            errors: {
                400: `Invalid status value or sort parameter`,
                500: `Failed to list children`,
            },
        });
    }
    /**
     * Create a child
     * Create a new child
     * @param child Child data
     * @returns models_Child Created
     * @throws ApiError
     */
    public static postApiV1Children(
        child: children_CreateChildRequest,
    ): CancelablePromise<models_Child> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children',
            body: child,
            errors: {
                400: `Validation errors or invalid request format`,
                500: `Failed to create child`,
            },
        });
    }
    /**
     * List allergies for a child
     * List all allergies for a specific child
     * @param childId Child ID
     * @returns children_AllergyListResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenAllergies(
        childId: string,
    ): CancelablePromise<children_AllergyListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/allergies',
            path: {
                'childId': childId,
            },
            errors: {
                400: `Missing child ID`,
                500: `Failed to list allergies`,
            },
        });
    }
    /**
     * Create a new allergy
     * Create a new allergy for a child
     * @param childId Child ID
     * @param allergy Allergy to create
     * @returns children_AllergyResponse Created
     * @throws ApiError
     */
    public static postApiV1ChildrenAllergies(
        childId: string,
        allergy: children_CreateAllergyRequest,
    ): CancelablePromise<children_AllergyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/{childId}/allergies',
            path: {
                'childId': childId,
            },
            body: allergy,
            errors: {
                400: `Invalid request body`,
                500: `Failed to create allergy`,
            },
        });
    }
    /**
     * Delete an allergy
     * Soft delete an allergy
     * @param childId Child ID
     * @param id Allergy ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenAllergies(
        childId: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{childId}/allergies/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            errors: {
                400: `Missing child ID or allergy ID`,
                500: `Failed to delete allergy`,
            },
        });
    }
    /**
     * Get an allergy by ID
     * Get an allergy by ID for a specific child
     * @param childId Child ID
     * @param id Allergy ID
     * @returns children_AllergyResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenAllergies1(
        childId: string,
        id: string,
    ): CancelablePromise<children_AllergyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/allergies/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            errors: {
                400: `Missing child ID or allergy ID`,
                404: `Allergy not found`,
                500: `Failed to get allergy`,
            },
        });
    }
    /**
     * Update an allergy
     * Update an existing allergy
     * @param childId Child ID
     * @param id Allergy ID
     * @param allergy Allergy update
     * @returns children_AllergyResponse OK
     * @throws ApiError
     */
    public static putApiV1ChildrenAllergies(
        childId: string,
        id: string,
        allergy: children_UpdateAllergyRequest,
    ): CancelablePromise<children_AllergyResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/children/{childId}/allergies/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            body: allergy,
            errors: {
                400: `Invalid request body`,
                404: `Allergy not found`,
                500: `Failed to update allergy`,
            },
        });
    }
    /**
     * List selected diets for a child
     * List all selected diets for a specific child
     * @param childId Child ID
     * @returns children_DietSelectionListResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenDiets(
        childId: string,
    ): CancelablePromise<children_DietSelectionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/diets',
            path: {
                'childId': childId,
            },
            errors: {
                400: `Missing child ID`,
                500: `Failed to list selected diets`,
            },
        });
    }
    /**
     * Deselect a diet for a child
     * Remove a diet definition from a child
     * @param childId Child ID
     * @param dietId Diet Definition ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenDiets(
        childId: string,
        dietId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{childId}/diets/{dietId}',
            path: {
                'childId': childId,
                'dietId': dietId,
            },
            errors: {
                400: `Missing IDs`,
                404: `Diet not selected for this child`,
                500: `Failed to deselect diet`,
            },
        });
    }
    /**
     * Select a diet for a child
     * Assign a diet definition to a child
     * @param childId Child ID
     * @param dietId Diet Definition ID
     * @returns children_DietSelectionResponse Created
     * @throws ApiError
     */
    public static postApiV1ChildrenDiets(
        childId: string,
        dietId: string,
    ): CancelablePromise<children_DietSelectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/{childId}/diets/{dietId}',
            path: {
                'childId': childId,
                'dietId': dietId,
            },
            errors: {
                400: `Missing IDs or diet already selected`,
                404: `Child or diet definition not found`,
                500: `Failed to select diet`,
            },
        });
    }
    /**
     * List diseases for a child
     * List all diseases for a specific child
     * @param childId Child ID
     * @returns children_DiseaseListResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenDiseases(
        childId: string,
    ): CancelablePromise<children_DiseaseListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/diseases',
            path: {
                'childId': childId,
            },
            errors: {
                400: `Missing child ID`,
                500: `Failed to list diseases`,
            },
        });
    }
    /**
     * Create a new disease
     * Create a new disease for a child
     * @param childId Child ID
     * @param disease Disease to create
     * @returns children_DiseaseResponse Created
     * @throws ApiError
     */
    public static postApiV1ChildrenDiseases(
        childId: string,
        disease: children_CreateDiseaseRequest,
    ): CancelablePromise<children_DiseaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/{childId}/diseases',
            path: {
                'childId': childId,
            },
            body: disease,
            errors: {
                400: `Invalid request body`,
                500: `Failed to create disease`,
            },
        });
    }
    /**
     * Delete a disease
     * Soft delete a disease
     * @param childId Child ID
     * @param id Disease ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenDiseases(
        childId: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{childId}/diseases/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            errors: {
                400: `Missing child ID or disease ID`,
                404: `Disease not found`,
                500: `Failed to delete disease`,
            },
        });
    }
    /**
     * Get a disease by ID
     * Get a disease by ID for a specific child
     * @param childId Child ID
     * @param id Disease ID
     * @returns children_DiseaseResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenDiseases1(
        childId: string,
        id: string,
    ): CancelablePromise<children_DiseaseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/diseases/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            errors: {
                400: `Missing child ID or disease ID`,
                404: `Disease not found`,
                500: `Failed to get disease`,
            },
        });
    }
    /**
     * Update a disease
     * Update an existing disease
     * @param childId Child ID
     * @param id Disease ID
     * @param disease Disease update
     * @returns children_DiseaseResponse OK
     * @throws ApiError
     */
    public static putApiV1ChildrenDiseases(
        childId: string,
        id: string,
        disease: children_UpdateDiseaseRequest,
    ): CancelablePromise<children_DiseaseResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/children/{childId}/diseases/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            body: disease,
            errors: {
                400: `Invalid request body`,
                404: `Disease not found`,
                500: `Failed to update disease`,
            },
        });
    }
    /**
     * List medications for a child
     * List all medications for a specific child
     * @param childId Child ID
     * @returns children_MedicationListResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenMedications(
        childId: string,
    ): CancelablePromise<children_MedicationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/medications',
            path: {
                'childId': childId,
            },
            errors: {
                400: `Missing child ID`,
                500: `Failed to list medications`,
            },
        });
    }
    /**
     * Create a new medication
     * Create a new medication for a child
     * @param childId Child ID
     * @param medication Medication to create
     * @returns children_MedicationResponse Created
     * @throws ApiError
     */
    public static postApiV1ChildrenMedications(
        childId: string,
        medication: children_CreateMedicationRequest,
    ): CancelablePromise<children_MedicationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/{childId}/medications',
            path: {
                'childId': childId,
            },
            body: medication,
            errors: {
                400: `Invalid request body`,
                500: `Failed to create medication`,
            },
        });
    }
    /**
     * Delete a medication
     * Soft delete a medication
     * @param childId Child ID
     * @param id Medication ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenMedications(
        childId: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{childId}/medications/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            errors: {
                400: `Missing child ID or medication ID`,
                500: `Failed to delete medication`,
            },
        });
    }
    /**
     * Get a medication by ID
     * Get a medication by ID for a specific child
     * @param childId Child ID
     * @param id Medication ID
     * @returns children_MedicationResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenMedications1(
        childId: string,
        id: string,
    ): CancelablePromise<children_MedicationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/medications/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            errors: {
                400: `Missing child ID or medication ID`,
                404: `Medication not found`,
                500: `Failed to get medication`,
            },
        });
    }
    /**
     * Update a medication
     * Update an existing medication
     * @param childId Child ID
     * @param id Medication ID
     * @param medication Medication update
     * @returns children_MedicationResponse OK
     * @throws ApiError
     */
    public static putApiV1ChildrenMedications(
        childId: string,
        id: string,
        medication: children_UpdateMedicationRequest,
    ): CancelablePromise<children_MedicationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/children/{childId}/medications/{id}',
            path: {
                'childId': childId,
                'id': id,
            },
            body: medication,
            errors: {
                400: `Invalid request body`,
                404: `Medication not found`,
                500: `Failed to update medication`,
            },
        });
    }
    /**
     * List selected sleep habits for a child
     * List all selected sleep habits for a specific child
     * @param childId Child ID
     * @returns children_SleepHabitSelectionListResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenSleepHabits(
        childId: string,
    ): CancelablePromise<children_SleepHabitSelectionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/sleep-habits',
            path: {
                'childId': childId,
            },
            errors: {
                400: `Missing child ID`,
                500: `Failed to list selected sleep habits`,
            },
        });
    }
    /**
     * Deselect a sleep habit for a child
     * Remove a sleep habit definition from a child
     * @param childId Child ID
     * @param sleepHabitId Sleep Habit Definition ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenSleepHabits(
        childId: string,
        sleepHabitId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{childId}/sleep-habits/{sleepHabitId}',
            path: {
                'childId': childId,
                'sleepHabitId': sleepHabitId,
            },
            errors: {
                400: `Missing IDs`,
                404: `Sleep habit not selected for this child`,
                500: `Failed to deselect sleep habit`,
            },
        });
    }
    /**
     * Select a sleep habit for a child
     * Assign a sleep habit definition to a child
     * @param childId Child ID
     * @param sleepHabitId Sleep Habit Definition ID
     * @returns children_SleepHabitSelectionResponse Created
     * @throws ApiError
     */
    public static postApiV1ChildrenSleepHabits(
        childId: string,
        sleepHabitId: string,
    ): CancelablePromise<children_SleepHabitSelectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/{childId}/sleep-habits/{sleepHabitId}',
            path: {
                'childId': childId,
                'sleepHabitId': sleepHabitId,
            },
            errors: {
                400: `Missing IDs or sleep habit already selected`,
                404: `Child or sleep habit definition not found`,
                500: `Failed to select sleep habit`,
            },
        });
    }
    /**
     * List selected toilet habits for a child
     * List all selected toilet habits for a specific child
     * @param childId Child ID
     * @returns children_ToiletHabitSelectionListResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenToiletHabits(
        childId: string,
    ): CancelablePromise<children_ToiletHabitSelectionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{childId}/toilet-habits',
            path: {
                'childId': childId,
            },
            errors: {
                400: `Missing child ID`,
                500: `Failed to list selected toilet habits`,
            },
        });
    }
    /**
     * Deselect a toilet habit for a child
     * Remove a toilet habit definition from a child
     * @param childId Child ID
     * @param toiletHabitId Toilet Habit Definition ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenToiletHabits(
        childId: string,
        toiletHabitId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{childId}/toilet-habits/{toiletHabitId}',
            path: {
                'childId': childId,
                'toiletHabitId': toiletHabitId,
            },
            errors: {
                400: `Missing IDs`,
                404: `Toilet habit not selected for this child`,
                500: `Failed to deselect toilet habit`,
            },
        });
    }
    /**
     * Select a toilet habit for a child
     * Assign a toilet habit definition to a child
     * @param childId Child ID
     * @param toiletHabitId Toilet Habit Definition ID
     * @returns children_ToiletHabitSelectionResponse Created
     * @throws ApiError
     */
    public static postApiV1ChildrenToiletHabits(
        childId: string,
        toiletHabitId: string,
    ): CancelablePromise<children_ToiletHabitSelectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/{childId}/toilet-habits/{toiletHabitId}',
            path: {
                'childId': childId,
                'toiletHabitId': toiletHabitId,
            },
            errors: {
                400: `Missing IDs or toilet habit already selected`,
                404: `Child or toilet habit definition not found`,
                500: `Failed to select toilet habit`,
            },
        });
    }
    /**
     * Delete a child
     * Delete a child by ID
     * @param id Child ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Children(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing child ID`,
                404: `Child not found`,
                500: `Failed to delete child`,
            },
        });
    }
    /**
     * Get a child by ID
     * Get a child by ID. A parent (or an admin viewing as one) gets the parent projection children.ParentChildResponse: id, createdAt, orgId, status, avatarUrl, firstname, lastname, gender, birthdate, nationalities and the allergies, diseases, medications and selected diets and habits, with no audit or staff fields; createdBy and childInternalId are always empty. Staff get the full model.
     * @param id Child ID
     * @returns models_Child OK
     * @throws ApiError
     */
    public static getApiV1Children1(
        id: string,
    ): CancelablePromise<models_Child> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing child ID`,
                404: `Child not found`,
                500: `Failed to get child`,
            },
        });
    }
    /**
     * Update a child
     * Update an existing child with all fields and relations
     * @param id Child ID
     * @param child Updated child data
     * @returns models_Child OK
     * @throws ApiError
     */
    public static putApiV1Children(
        id: string,
        child: children_UpdateChildRequest,
    ): CancelablePromise<models_Child> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/children/{id}',
            path: {
                'id': id,
            },
            body: child,
            errors: {
                400: `Validation errors, invalid request format, or missing child ID`,
                404: `Child not found`,
                409: `Concurrent modification detected`,
                500: `Failed to update child`,
            },
        });
    }
    /**
     * Attendance list of a child (Praesenzliste)
     * Per calendar day of the range: the contracted service of the version in force, the first check-in and last check-out, a reported absence and its type, an extra day, closures; per month the versions in force with BF and SBU, the PID, the issued invoices and the totals. At most 12 calendar months. Requires a child-detail module and billing or contracts-tariffs.
     * @param id Child ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD
     * @returns children_ChildAttendanceResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenAttendance(
        id: string,
        from: string,
        to: string,
    ): CancelablePromise<children_ChildAttendanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/attendance',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long range`,
                401: `Authentication required`,
                403: `Module grant missing or organization ID not found in token`,
                404: `Child not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Download the attendance list of a child as PDF
     * A4 portrait, one page per child-month. German by default; lang selects another document language.
     * @param id Child ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD
     * @param lang Document language
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1ChildrenAttendancePdf(
        id: string,
        from: string,
        to: string,
        lang?: 'de' | 'en' | 'fr' | 'it' | 'es' | 'pt',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/attendance/pdf',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
                'lang': lang,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long range, or an unknown language`,
                401: `Authentication required`,
                403: `Module grant missing or organization ID not found in token`,
                404: `Child not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Download the attendance list of a child as XLSX
     * One sheet per child-month named "<lastname> <firstname> <YYYY-MM>", the day table with a frozen header row, the totals and the month's header fields below it.
     * @param id Child ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD
     * @param lang Document language
     * @returns binary XLSX file
     * @throws ApiError
     */
    public static getApiV1ChildrenAttendanceXlsx(
        id: string,
        from: string,
        to: string,
        lang?: 'de' | 'en' | 'fr' | 'it' | 'es' | 'pt',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/attendance/xlsx',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
                'lang': lang,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long range, or an unknown language`,
                401: `Authentication required`,
                403: `Module grant missing or organization ID not found in token`,
                404: `Child not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get complete audit history for a child
     * Get paginated complete audit history including all related entities (allergies, medications, etc.)
     * @param id Child ID
     * @param page Page number (default: 1)
     * @param limit Page size (default: 20, max: 100)
     * @returns children_audit_UnifiedAuditHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenAuditComplete(
        id: string,
        page?: number,
        limit?: number,
    ): CancelablePromise<children_audit_UnifiedAuditHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/audit/complete',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get complete audit history`,
            },
        });
    }
    /**
     * Remove a child's profile photo
     * Soft-deletes the attached avatar image and clears the child's pointer in one transaction. Staff only (admin or employee); parents are rejected. Returns 404 when the child has no profile photo.
     * @param id Child ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenAvatar(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{id}/avatar',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid child ID`,
                401: `Unauthorized`,
                403: `User or Organization ID not found in token`,
                404: `Child not found, or the child has no profile photo`,
                500: `Failed to remove the profile photo`,
            },
        });
    }
    /**
     * Set or replace a child's profile photo
     * Binds a confirmed avatar upload to the child and soft-deletes the photo it replaces, in one transaction. Staff only (admin or employee); parents are rejected. Touches no other child column and does not go through the change-request inbox.
     * @param id Child ID
     * @param request Confirmed avatar image id
     * @returns children_ChildAvatarResponse Profile photo set
     * @throws ApiError
     */
    public static putApiV1ChildrenAvatar(
        id: string,
        request: children_SetChildAvatarRequest,
    ): CancelablePromise<children_ChildAvatarResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/children/{id}/avatar',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Missing or invalid child ID, or the image cannot be used as the profile photo`,
                401: `Unauthorized`,
                403: `User or Organization ID not found in token`,
                404: `Child not found`,
                500: `Failed to set the profile photo`,
            },
        });
    }
    /**
     * Delete a child's signed-contract document
     * Soft-deletes the attached image and clears the child's pointer in one transaction. Staff only. Does not change contract_signed.
     * @param id Child ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ChildrenContractDocument(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/children/{id}/contract-document',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid child ID`,
                403: `User or Organization ID not found in token`,
                404: `Child has no contract document`,
                500: `Failed to delete contract document`,
            },
        });
    }
    /**
     * Get a child's expected drop-off and pick-up times
     * Always 7 entries, one per ISO weekday: the booked window of the child's current
     * allocation, the expected times entered by staff or a parent, and the check-in
     * history value. For staff, and for parents of the child.
     * @param id Child ID
     * @returns children_ChildExpectedTimesResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenExpectedTimes(
        id: string,
    ): CancelablePromise<children_ChildExpectedTimesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/expected-times',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid child ID`,
                401: `Authentication required`,
                403: `Access denied`,
                404: `Child not found`,
                500: `An error occurred processing your request`,
            },
        });
    }
    /**
     * Replace a child's expected drop-off and pick-up times
     * Replaces the full weekly set (0-7 entries). A weekday missing from the request
     * loses its expected time. The server records whether staff or a parent wrote it.
     * Returns the same 7 entries as the GET route.
     * @param id Child ID
     * @param request Full weekly set
     * @returns children_ChildExpectedTimesResponse OK
     * @throws ApiError
     */
    public static putApiV1ChildrenExpectedTimes(
        id: string,
        request: children_ReplaceChildExpectedTimesRequest,
    ): CancelablePromise<children_ChildExpectedTimesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/children/{id}/expected-times',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation failed`,
                401: `Authentication required`,
                403: `Access denied`,
                404: `Child not found`,
                500: `An error occurred processing your request`,
            },
        });
    }
    /**
     * Get a child with all relations
     * Get a child by ID including all related data (labels, allergies, etc.). A parent (or an admin viewing as one) gets the parent projection children.ParentChildResponse: id, createdAt, orgId, status, avatarUrl, firstname, lastname, gender, birthdate, nationalities and the allergies, diseases, medications and selected diets and habits, with no audit or staff fields; createdBy and childInternalId are always empty. Staff get the full model.
     * @param id Child ID
     * @returns models_Child OK
     * @throws ApiError
     */
    public static getApiV1ChildrenFull(
        id: string,
    ): CancelablePromise<models_Child> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/full',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing child ID`,
                404: `Child not found`,
                500: `Failed to get child`,
            },
        });
    }
    /**
     * Get audit history for a child
     * Get paginated audit history for a specific child
     * @param id Child ID
     * @param page Page number (default: 1)
     * @param limit Page size (default: 20, max: 100)
     * @returns children_audit_ChildrenAuditHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenHistory(
        id: string,
        page?: number,
        limit?: number,
    ): CancelablePromise<children_audit_ChildrenAuditHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get audit history`,
            },
        });
    }
    /**
     * Get field change history for a child
     * Get the history of changes to a specific field
     * @param id Child ID
     * @param field Field name
     * @returns children_audit_ChildrenAuditRecord OK
     * @throws ApiError
     */
    public static getApiV1ChildrenHistoryField(
        id: string,
        field: string,
    ): CancelablePromise<Array<children_audit_ChildrenAuditRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/history/field/{field}',
            path: {
                'id': id,
                'field': field,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Organization ID not found in token`,
                404: `Unknown field`,
                500: `Failed to get field history`,
            },
        });
    }
    /**
     * Get recent changes for a child
     * Get the last 10 changes to a child
     * @param id Child ID
     * @returns children_audit_ChildrenAuditRecord OK
     * @throws ApiError
     */
    public static getApiV1ChildrenHistoryRecent(
        id: string,
    ): CancelablePromise<Array<children_audit_ChildrenAuditRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/history/recent',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing child ID`,
                403: `Organization ID not found in token`,
                500: `Failed to get recent changes`,
            },
        });
    }
    /**
     * Get a child's attendance schedule
     * Returns the regular weekly bookings (current and future), running courses, upcoming extra days, and ongoing or upcoming absences of a child, cut at today in the organisation's timezone. Staff only (admin or employee); parents are rejected.
     * @param id Child ID
     * @returns children_ChildScheduleResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenSchedule(
        id: string,
    ): CancelablePromise<children_ChildScheduleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/schedule',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid child ID`,
                401: `Unauthorized`,
                403: `Organization ID not found or no child-detail module`,
                500: `Failed to load the schedule`,
            },
        });
    }
    /**
     * Get household cohort (siblings) for children
     * Returns, per requested child, the household siblings derived from the shared billing payer / family group (Decision D2 - household-only). Batched and tenant-scoped; a cross-tenant/unknown id yields 404; an only-child yields an empty siblings set.
     * @param childIds Comma-separated child IDs
     * @returns children_ChildCohortResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenCohort(
        childIds: string,
    ): CancelablePromise<children_ChildCohortResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/cohort',
            query: {
                'child_ids': childIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Headcount of active children by weekday
     * Counts distinct active children booked on each weekday (Mon–Fri) as of a date, optionally scoped to a childcare and/or group. Staff only.
     * @param asOf Snapshot date (YYYY-MM-DD); defaults to today
     * @param childcareId Filter to a childcare
     * @param groupId Filter to a group
     * @returns children_WeekdayHeadcountResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenHeadcountByWeekday(
        asOf?: string,
        childcareId?: string,
        groupId?: string,
    ): CancelablePromise<children_WeekdayHeadcountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/headcount-by-weekday',
            query: {
                'as_of': asOf,
                'childcare_id': childcareId,
                'group_id': groupId,
            },
            errors: {
                400: `Invalid as_of date`,
                401: `Unauthorized`,
                403: `Organization ID not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Get next available child internal ID
     * Returns the next sequential child internal ID for the organization
     * @returns children_NextInternalIDResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenNextInternalId(): CancelablePromise<children_NextInternalIDResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/next-internal-id',
            errors: {
                500: `Failed to get next internal ID`,
            },
        });
    }
}
